import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { BuyersSection } from '../components/BuyersSection';
export const BuyersPage = () => {
  return <div className="min-h-screen bg-[#f2f2ed]" data-id="element-921">
      <Header data-id="element-922" />
      <main data-id="element-923">
        <BuyersSection data-id="element-924" />
      </main>
      <Footer data-id="element-925" />
    </div>;
};